export default __webpack_public_path__ + "static/media/hot-air-balloon.c2380512.svg";